import React, {useEffect, useState} from 'react';
import { withTranslation } from 'react-i18next';
import {useHistory, useParams} from 'react-router-dom';

import useRequest from '../../hooks/useRequest';
import { useStore } from "store/context";

import GradientButton from '../../components/atoms/GradientButton';
import MainLayout from '../../components/Layouts/MainLayout';
import InputText from '../../components/atoms/InputText';

import './styles.scss';
import Box from "../../components/atoms/Box";
import Form from "react-bootstrap/Form";
import Radio from "react-bootstrap/FormCheck";
import {UnidadService} from "../../services/UnidadService";

import Modal from 'components/atoms/Modal';

const AltaDebitoView = (props) => {
    const history = useHistory();

    const {
        submitted, success, message, errors,
        beforeSubmit, afterSubmit, showError,
        dealWithError
    } = useRequest();

    const [{
        uf,  // La uf actual seleccionada
    }, dispatch] = useStore();

    const titleDebito = <>
        <strong>UF</strong> {uf.unidad} - {uf.alias}
    </>;

    const { id, campo } = useParams();

    const [cbu, setCbu] = useState("");
    const [tarjeta, setTarjeta] = useState("");
    const [tipoDebito, setTipoDebito] = useState("C");
    const [checkTipoDebito, setCheckTipoDebito] = useState(true);
    const [titular, setTitular] = useState("");
    const [numeroDocumento, setNumeroDocumento] = useState("");
    const [cuit, setCuit] = useState("");
    const [tipoDocumento, setTipoDocumento] = useState("DNI");
    
    const [showAltaDebito, setShowAltaDebito] = useState(false);

    const handleCloseAltaDebito = () => {
        setShowAltaDebito(false);
        history.push('/home');
    }

    const bodyAltaDebito = <span className="confirmar-baja-body">
        <h3>DÉBITO AUTOMÁTICO</h3>
        <div className="confirmar-baja-container">
            <div className="confirmar-baja-content baja-confirmar">

                {(campo == 1) && <p className="confirmar-baja-mensaje">La Unidad fue dada de alta al débito automático de facturas.</p>}
                {(campo == 2) && <p className="confirmar-baja-mensaje">La Unidad fue dada de alta al débito automático de planes de financiación.</p>}
                {(campo == 3) && <p className="confirmar-baja-mensaje">La Unidad fue dada de alta al débito automático de facturas y planes de financiación.</p>}

                <div className="confirmar-baja-button">
                    <GradientButton legend={'CERRAR'} handleClick={handleCloseAltaDebito} />
                </div>
            </div>
        </div>
    </span>;


    const onTipoChange = (event) => {
        setTipoDebito(event.target.value);
        setCheckTipoDebito(!checkTipoDebito);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        beforeSubmit();
        console.log(campo);
        const data = {
            tipo_documento: tipoDocumento,
            numero_documento: numeroDocumento,
            cuit: cuit,
            numero: (tipoDebito === "C") ? cbu : tarjeta,
            tipo_debito: tipoDebito,
            titular: titular,
            campo: campo,
        }
        UnidadService.altaDebito(data, id)
            .then(data => {
                afterSubmit();
                //history.push('/home');
                setShowAltaDebito(true);
            }).catch((error) => {
                afterSubmit();
                dealWithError(error, 'No se pudo adherir a débito automático');
            });
    }

    const handleCancelar = (e) => {
        e.preventDefault();
        history.push('/home');
    }

    const maxLengthCheck = (object) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }

    return (<>
        <MainLayout>
            <div className="debito-container">
                <div className="debito-content">
                    <Box header="DÉBITO AUTOMÁTICO" body={
                        <form className="debito-form" onSubmit={handleSubmit}>
                            <Form.Group>
                                <Form.Label>TIPO DE DÉBITO AUTOMÁTICO</Form.Label>
                                <Radio inline name="tipoDebito" value="C" type='radio' onClick={onTipoChange} checked={checkTipoDebito} label='Débito Automático en CBU' id="debito-cbu"/>
                                <Radio inline name="tipoDebito" value="T" type='radio' onClick={onTipoChange} checked={!checkTipoDebito} label='Débito Automático en Tarjeta de Crédito' id="debito-tarjeta"/>
                            </Form.Group>
                            <InputText id="cbu" label="CBU" type="number" maxLength="22" onInput={maxLengthCheck} placeholder="Hasta 22 dígitos" handleChange={(event) => { setCbu(event.target.value) }} otherClass={checkTipoDebito ? 'show' : 'hide'} error={errors.numero}/>
                            <InputText id="numero_tarjeta" label="NÚMERO DE TARJETA" maxLength="16" onInput={maxLengthCheck} placeholder="Hasta 16 dígitos" type="number" handleChange={(event) => { setTarjeta(event.target.value) }} otherClass={!checkTipoDebito ? 'show' : 'hide'} error={errors.numero}/>
                            <InputText id="titular" label="TITULAR" type="text" handleChange={(event) => { setTitular(event.target.value) }} error={errors.titular}/>
                            <Form.Group controlId="debito-dropdown-select">
                                <Form.Label>TIPO DOCUMENTO</Form.Label>
                                <Form.Control
                                    custom
                                    as="select"
                                    size="lg"
                                    value={tipoDocumento}
                                    onChange={(event) => { setTipoDocumento(event.target.value) }}>
                                    <option value="DNI">DNI</option>
                                    <option value="CUIT">CUIT</option>
                                </Form.Control>
                            </Form.Group>
                            <div className="input-error">
                                {errors.tipo_documento}
                            </div>
                            {tipoDocumento === 'DNI' && <InputText id="numero_documento" label="NÚMERO DE DOCUMENTO" placeholder="Hasta 8 dígitos" type="text" maxLength="8" onInput={maxLengthCheck} handleChange={(event) => { setNumeroDocumento(event.target.value) }} error={errors.numero_documento}/>}
                            {tipoDocumento === 'CUIT' && <InputText id="cuit" label="CUIT" placeholder="Hasta 11 dígitos" type="text" maxLength="11" onInput={maxLengthCheck} handleChange={(event) => { setCuit(event.target.value) }} error={errors.cuit} />}
                            {(success === false && message) &&
                                <p className="error-messages">{message}</p>
                            }
                            <div className="debito-botones">
                                <div className="debito-button">
                                    <GradientButton legend={'SOLICITAR ADHESIÓN'} handleClick={handleSubmit}/>
                                </div>
                                <div className="debito-button debito-button-cancelar">
                                    <GradientButton legend={'CANCELAR'} handleClick={handleCancelar}/>
                                </div>
                            </div>
                        </form>
                    } >
                    </Box>
                </div>
            </div>
        </MainLayout>
        <Modal className="modal-debito-automatico" title={titleDebito} body={bodyAltaDebito} legend={""} handleClose={handleCloseAltaDebito} show={showAltaDebito}></Modal>
        </>
    );
}

export default withTranslation()(AltaDebitoView);